// =============================================================================
// Portfolio Data — Peter B. South (from resume)
// =============================================================================

// Single source of truth for nav labels and section ids (used by Header and
// the scroll spy in App).
export const NAV_ITEMS = [
  { label: 'Home', id: 'home' },
  { label: 'Education', id: 'education' },
  { label: 'About', id: 'about' },
  { label: "Let's connect.", id: 'contact' },
];

export const SECTION_IDS = NAV_ITEMS.map((item) => item.id);

export const PORTFOLIO = {
  name: 'Peter B. South',
  title: 'Statistics & Analytics',
  email: 'pbsouth@unc.edu',
  phone: '919-886-1189',
  links: {
    github: 'https://github.com/pbsouth04',
    linkedin: 'https://www.linkedin.com/in/peter-south-5b46532ab/',
    probe: 'https://probedaily.com/',
  },
  education: {
    school: 'University of North Carolina at Chapel Hill',
    degree: 'B.S. Statistics and Analytics · Minor in Data Science',
    coursework: [
      'Database Systems I',
      'Methods and Models of Data Science',
      'Methods of Data Analysis',
      'Discrete Math',
      'Calculus II',
      'Financial Accounting',
      'Managerial Accounting',
      'Macroeconomics',
      'Microeconomics',
      'Intermediate Microeconomics',
    ],
    newsSources: [
      {
        name: 'The Wall Street Journal',
        shortName: 'WSJ',
        url: 'https://www.wsj.com',
        logo: 'https://www.google.com/s2/favicons?domain=wsj.com&sz=128',
      },
      {
        name: 'MarketWatch',
        shortName: 'MarketWatch',
        url: 'https://www.marketwatch.com',
        logo: 'https://www.google.com/s2/favicons?domain=marketwatch.com&sz=128',
      },
    ],
  },
  about: `This summer I was a Summer Analyst at RCG Ventures, an Atlanta-based retail real estate private equity firm with ~$2.4B AUM, where I underwrote acquisitions and dispositions of anchored shopping centers in Argus and Excel. I won first place in the firm's intern case competition with a three-phase repositioning strategy for an RCG-owned shopping center, and built an internal AI tool that automates disposition sale packages, saving ~2 hours per property. At Encoded Therapeutics, a clinical-stage gene therapy startup, I worked on manufacturing and supply chain operations, contributing to the company's first GMP cell-vial thaw for EXT101. I founded UN-JUNKED LLC, a junk removal business primarily focused on working with local real estate agents and small businesses, serving 330+ clients and bringing in nearly $32,250 in revenue.`,
};

// =============================================================================
// Live Ticker Data
// =============================================================================

export const TICKER_SYMBOLS = [
  'AAPL', 'NVDA', 'MSFT', 'AMZN', 'TSLA', 'GOOGL',
  'META', 'JPM', 'V', 'WMT', 'IBM', 'INFY',
];

export const FALLBACK_STOCKS = [
  { symbol: 'AAPL', price: 233.5, previousClose: 229.8 },
  { symbol: 'NVDA', price: 139.12, previousClose: 141.6 },
  { symbol: 'MSFT', price: 448.62, previousClose: 443.9 },
  { symbol: 'AMZN', price: 241.73, previousClose: 238.4 },
  { symbol: 'TSLA', price: 416.56, previousClose: 410.2 },
  { symbol: 'GOOGL', price: 212.8, previousClose: 215.5 },
  { symbol: 'META', price: 658.4, previousClose: 651.7 },
  { symbol: 'JPM', price: 261.9, previousClose: 258.3 },
  { symbol: 'V', price: 312.45, previousClose: 314.8 },
  { symbol: 'WMT', price: 98.76, previousClose: 97.2 },
  { symbol: 'IBM', price: 191.71, previousClose: 190.9 },
  { symbol: 'INFY', price: 40.88, previousClose: 41.25 },
];
